export default {
      id: "ic_comments-usage",
      viewBox: "0 0 20 18",
      url: "/" + "images/icons.3.109.2.svg#ic_comments-usage",
      toString: function () {
        return this.url;
      }
    }